module.exports = __webpack_public_path__ + "static/southern-tire-masters-logo-ab8c6a489d3f965e3979e04a570a1f2b.jpg";